import { PatientRepository } from '../contracts/repositories';
import { Patient } from '../entities';

export class PatientService {
  constructor(private readonly patientRepository: PatientRepository) {}

  async findOneById(id: string): Promise<Patient> {
    const patient = await this.patientRepository.findOne(id);
    return patient;
  }

  async findOneBySSN(ssn: string): Promise<Patient> {
    return await this.patientRepository.findOneBySSN(ssn);
  }

  async findWithPagination(): Promise<Patient[]> {
    const patients = await this.patientRepository.findWithPagination();
    return patients;
  }

  async set(patient: Patient): Promise<Patient> {
    let newPatient: Patient;

    if (patient.id) {
      newPatient = await this.patientRepository.update(patient);
    } else {
      newPatient = await this.patientRepository.create(patient);
    }

    return newPatient;
  }
}
